import { API, graphqlOperation } from "aws-amplify"
import {
	getUser,
	getUserUnAuth,
	getProject,
	getRating
} from "../../graphql/queries"

export const get_user_function = async (user_id, user) => {
	if (Object.keys(user).length !== 0) {
		let getuser = await API.graphql(graphqlOperation(getUser(user_id)))
		let userInfo = {}
		if (getuser.data.getUser.length > 0) {
			userInfo = {
				...getuser.data.getUser[0],
				given_name: getuser.data.getUser[0].first_name,
				family_name: getuser.data.getUser[0].last_name,
				image: getuser.data.getUser[0].profile_picture
			}
		}
		return userInfo
	} else {
		let getuser = await API.graphql(graphqlOperation(getUserUnAuth(user_id)))
		let userInfo = {}
		if (getuser.data.getUser.length > 0 && getuser.data.getUser !== null) {
			userInfo = {
				...getuser.data.getUser[0],
				given_name: getuser.data.getUser[0].first_name,
				family_name: getuser.data.getUser[0].last_name,
				image: getuser.data.getUser[0].profile_picture
			}
			if (!!userInfo.first_name) {
				delete userInfo.first_name
			}
			if (!!userInfo.last_name) {
				delete userInfo.last_name
			}
			if (!!userInfo.profile_picture) {
				delete userInfo.profile_picture
			}
		}
		return userInfo
	}
}

export const get_ref_project = async project_id => {
	let projectinfo = await API.graphql(graphqlOperation(getProject(project_id)))
	return projectinfo.data.getProject.data[0]
}

export const get_all_rating = async project_id => {
	let result = await API.graphql(
		graphqlOperation(getRating("PROJECT", project_id, null))
	)
	let rating = JSON.parse(result.data.getRating.body)
	let sum = 0
	rating.Items.map(item => (sum = sum + item.rating_score))
	let average = (sum / rating.Count).toFixed(2)
	return { average, count: rating.Count }
}
